import { Platform } from 'react-native';

export const scrollToSection = (target: string) => {
  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(`[id="${target}"]`));
    const visibleNode = nodes.find((node) => node.offsetParent !== null) ?? nodes[nodes.length - 1];
    visibleNode?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
